import { useEffect } from "react";
import { useNotify } from "react-admin";

import { useNotifyError } from "../../../utils/notifiers/useNotifyError";
import { useTerminalContext } from "../contexts/TerminalContext";

/**
 * Hook to show toast notifications when terminal config errors occur
 */
export function useTerminalConfigErrorNotifications() {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const { error } = useTerminalContext();

  useEffect(() => {
    if (!error) return;

    if (error === "NO_CONFIG_FOUND") {
      // UI shows empty-state card; skip toast to avoid noise
      return;
    } else if (error === "LOAD_ERROR") {
      notify("Failed to load configuration. Please try again.", "error");
    } else {
      notifyError(error);
    }
  }, [error, notify, notifyError]);
}
